/**
 * 打印带有样式的日志信息
 * @param infoArray - 信息数组
 */
export function buildInfoLogFromArray(infoArray) {
  const baseStyle = 'padding: 2px 1px; color: #fff;'
  const labelStyle = 'border-radius: 3px 0 0 3px; background: #35495e;'
  const valueStyleBase = 'border-radius: 0 3px 3px 0;'
  const log = window.console.log

  infoArray.forEach((item) => {
    const { key, val, color } = item
    const valueStyle = `${baseStyle} ${valueStyleBase} background: ${color};`

    log(
      `%c ${capitalizeFirstLetter(key)} %c ${val} %c`,
      baseStyle + labelStyle,
      valueStyle,
      'background: transparent;',
    )
  })
}

/**
 * 首字母大写
 * @param str - 输入字符串
 * @returns 首字母大写的字符串
 */
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
